module.exports = __webpack_public_path__ + "HSA PNC Investment info.pdf";